import { useAuth } from "@clerk/clerk-react";
import { useEffect } from "react";

import { setTokenProvider } from "../lib/api";
import { setUploadTokenProvider } from "../lib/uploadKnowledge";

/**
 * Glues Clerk's `useAuth().getToken()` to our plain fetch-based API client.
 *
 * The API client (`lib/api.ts`) holds a module-level callable. This
 * component subscribes once, on mount, and re-subscribes whenever Clerk's
 * `getToken` reference changes (typically: never inside one session, but
 * react conservatively).
 *
 * Renders nothing.
 */
export function ApiTokenBridge() {
  const { getToken, isLoaded } = useAuth();

  useEffect(() => {
    if (!isLoaded) return;
    const provider = async () => {
      // `template: undefined` returns the default session token. Clerk
      // rotates this every ~60 seconds; `getToken` always returns a
      // fresh one. No need to cache ourselves.
      try {
        return await getToken();
      } catch {
        return null;
      }
    };
    setTokenProvider(provider);
    setUploadTokenProvider(provider);
    return () => {
      setTokenProvider(null);
      setUploadTokenProvider(null);
    };
  }, [getToken, isLoaded]);

  return null;
}
